/**
 * WooCommerce All Products for Subscriptions (WCS-ATT) handler.
 *
 * Reads subscription scheme selection from the DOM and passes it via
 * the Store API extensions.caddy field. A PHP bridge hook
 * (bridge_wcsatt_from_store_api) populates $_REQUEST so WCS-ATT
 * applies the scheme during add-to-cart, giving the item a unique
 * cart key distinct from one-time purchases.
 */
export default {
	matches(form) {
		const wcsattWrapper = form.closest('.product')?.querySelector('.wcsatt-options-wrapper')
			|| document.querySelector('.wcsatt-options-wrapper');
		return !!wcsattWrapper;
	},

	buildApiData(form) {
		const wcsattWrapper = form.closest('.product')?.querySelector('.wcsatt-options-wrapper')
			|| document.querySelector('.wcsatt-options-wrapper');

		let schemeKey = null;
		if (wcsattWrapper) {
			const promptInput = wcsattWrapper.querySelector('.wcsatt-options-prompt-action-input:checked');
			if (promptInput && promptInput.value === 'no') {
				schemeKey = '0';
			} else {
				const schemeRadio = wcsattWrapper.querySelector('input[name^="convert_to_sub_"]:not([name*="dropdown"]):checked');
				if (schemeRadio && schemeRadio.value !== '0') {
					schemeKey = schemeRadio.value;
				} else {
					const schemeDropdown = wcsattWrapper.querySelector('.wcsatt-options-product-dropdown');
					if (schemeDropdown && schemeDropdown.value) {
						schemeKey = schemeDropdown.value;
					}
				}
			}
		}

		// Pass scheme to Store API via extensions so the PHP bridge can
		// populate $_REQUEST before WCS-ATT's woocommerce_add_cart_item_data hook
		if (schemeKey && schemeKey !== '0') {
			return {
				extensions: {
					caddy: { convert_to_sub: schemeKey }
				}
			};
		}

		return null;
	}
};
